import React from 'react'
import styled from 'styled-components'
import * as R from 'ramda'

export default function ReviewStars({ stars }) {
  // If the rating has a decimal value, the last star is filled that decimal percentage
  const ratingLastStar = (stars % 1).toFixed(1) * 100;
  const lastStarHasPercentage = ratingLastStar > 0;
  const strokeProps = {
    stroke: 'rgb(224 182 0)',
    strokeWidth: '10',
    // there's 2 edges that aren't sharp when zooming in but the linecap doesn't help -not visible because of the small size of the SVG-
    // strokeLinecap: 'butt'
  };

  return (
    <StarsWrapper>
      {R.times(
        (n) => (
          <svg key={n} fill='black' viewBox='0 0 260 245'>
            <path d='M0 87h91.76L120 0l28.24 87H240l-73.72 55.6L194 228l-70.66-51.36L46 228l28.25-87.04z' {...strokeProps} />
          </svg>
        ),
        Math.floor(stars),
      )}
      {lastStarHasPercentage && (
        <svg fill='black' viewBox='0 0 260 245'>
          <defs>
            <linearGradient 
              id='rating' x1={`${ratingLastStar}%`} y1='0%' x2={`${ratingLastStar + 0.1}%`} y2='0%'
            >
              <stop offset='0%' style={{ stopColor: 'rgb(251, 204, 0)', stopOpacity: 1 }} />
              <stop offset='100%' style={{ stopColor: 'transparent', stopOpacity: 1 }} />
            </linearGradient>
          </defs>
          <path 
            d='M0 87h91.76L120 0l28.24 87H240l-73.72 55.6L194 228l-70.66-51.36L46 228l28.25-87.04z' fill="url(#rating)" {...strokeProps} />
        </svg>
      )}
      {[...Array(Math.floor(5 - stars))].map( // the same than R.times().. is it worth it though?
        (n) => (
          <svg key={`empty-${n}`} className='empty' viewBox='0 0 260 245'>
            <path d='M0 87h91.76L120 0l28.24 87H240l-73.72 55.6L194 228l-70.66-51.36L46 228l28.25-87.04z' {...strokeProps} />
          </svg>
        )
      )}
    </StarsWrapper>
  )
}

const StarsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  white-space: nowrap;

  svg {
    width: 4vw;
    margin-right: ${(props) => props.theme.space.marginMobile / 8}vw;
    fill: rgb(251, 204, 0);

    &.empty {
      fill: transparent;
    }

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      width: ${(props) => props.theme.space.marginDesktop * 1.5}vw;
      margin-right: ${(props) => props.theme.space.marginDesktop / 8}vw;
    }
  }
`